module.exports = __webpack_public_path__ + "static/media/main-logo-color.2bf297c2.svg";